// extracted by mini-css-extract-plugin
module.exports = {"Row":"CommentReplyButton_Row__QM0O6","Button":"CommentReplyButton_Button__8nf44","AttachmentIcon":"CommentReplyButton_AttachmentIcon__gGq7K"};